import { InjectionToken } from '@angular/core';

export enum RegistrationTypes {
  FULL_LOOKUP = 'FULL_LOOKUP',
  PARTIAL_LOOKUP = 'PARTIAL_LOOKUP',
  NO_LOOKUP = 'NO' + '_LOOKUP'
}
export interface IndividualsModules {
  registrationType: string;
  auditTrail: boolean;
  addOns: boolean;
  changeBeneficiary: boolean;
  changePackage: boolean;
  changePaymentChannel: boolean;
  changeMSISDN: boolean;
  beneficiaries: boolean;
  dependants: boolean;
  editPolicyHolder: boolean;
  invoices: boolean;
  notifications: boolean;
  payments: boolean;
  bulkPayments: boolean;
  bulkPolicyHolders: boolean;
  bulkDependants: boolean;
  realization: boolean;
  refunds: boolean;
  refreshSubscriberDetails: boolean;
  removeBeneficiary: boolean;
  sponsor: boolean;
  policy: {
    close: boolean;
    activate: boolean;
    refund: boolean;
  };
  sockets: {
    policyNotification: boolean;
  };
}

export interface CommissionsModules {
  myRegistrations: boolean;
  agentCommissions: boolean;
  agentRegistrations: boolean;
  commissionsReport: boolean;
}

export interface ModulesConfiguration {
  individuals: IndividualsModules;
  commissions: CommissionsModules;
}

export const MODULES_CONFIGURATION_TOKEN = new InjectionToken<
  ModulesConfiguration
>('Configure EcoSure Modules');
